import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import { menuInfo } from "@shared/type/CommonType";

interface Props {
  Menuprops: menuInfo;
}

// B/F출고현황 — 조회 전용(ISS2026100103).
// 자재불출(통합) 중 입출고유형 B/F출고(cd_io=520, fg_map='2') 전표의 현황.
// 쿼리 sn_mtl_mow_rep_002_01 을 단일 그리드로 표시. 정렬은 쿼리(출고번호+항번)로 고정.
const SN_MTL_MOW_REP_002 = forwardRef(({ Menuprops }: Props, ref) => {
  const searchRef = useRef<any>(null);
  const gridRef = useRef<SnGridRef>(null);

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColumns] = useState<any[]>([]);
  const [dataSource, setDataSource] = useState<any[]>([]);

  useEffect(() => {
    const fetchForm = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData(rtn.formData);
        setColumns(rtn.grid.grid1);
      } catch (error) {}
    };
    fetchForm();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const onSearch = async () => {
    try {
      const data: any = await fnGetDataSet({
        id: "sn_mtl_mow_rep_002_01",
        params: searchRef.current?.getFormdata?.() ?? {},
      });
      const rows = data?.[0] ?? [];
      setDataSource(rows);
      if (!rows.length) {
        await showDialog("alter", "조회된 B/F출고 내역이 없습니다.");
      }
    } catch (error) {}
  };

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        />
      </div>
      <div className="flex-1 min-h-0">
        <SnGrid
          ref={gridRef}
          columnConfig={columns}
          rowData={dataSource}
          etcProps={{
            rowSelection: "single",
            isEditable: false,
          }}
        />
      </div>
    </div>
  );
});

export default SN_MTL_MOW_REP_002;
